// src/api/auth/authApi.ts
// identity's sign-in, session, refresh, sign-out and passwords (contract §6); MFA and passkeys are mfaApi.ts. Profile data is healthcare's.

import { http } from "../../lib/http/client";
import { ENV } from "../../config/runtimeEnv";
import type { AuthSessionInfo, LoginResponse, RefreshResponse } from "../../lib/http/session";

export const authBase = (): string => ENV.VITE_AUTH_SERVER || "/auth";

export const login = async (username: string, password: string): Promise<LoginResponse> => {
	const response = await http.post<LoginResponse>(`${authBase()}/login`, { username, password });
	return response.data;
};

export const fetchAuthSession = async (): Promise<AuthSessionInfo> => {
	const response = await http.get<AuthSessionInfo>(`${authBase()}/session`);
	return response.data;
};

// Only a refresh carrying {"activity": true} slides the idle expiry (contract §6.4, §6.10).
export const refresh = async (activity: boolean) => {
	return http.post<RefreshResponse>(`${authBase()}/refresh`, activity ? { activity: true } : undefined);
};

export const logout = async (): Promise<void> => {
	await http.post(`${authBase()}/logout`);
};

export const changePassword = async (currentPassword: string, password: string, passwordConfirmation: string) => {
	const response = await http.put(`${authBase()}/password`, {
		current_password: currentPassword,
		password,
		password_confirmation: passwordConfirmation,
	});
	return response.data;
};

export const requestPasswordReset = async (username: string) => {
	const response = await http.post(`${authBase()}/password/forgot`, { username });
	return response.data;
};

export const requestPasswordResetByEmail = async (email: string) => {
	const response = await http.post(`${authBase()}/password/forgot`, { email });
	return response.data;
};

// Always 202 with one fixed message, whether or not a link was due (contract §6.5).
export const resendVerificationEmail = async (): Promise<{ message: string }> => {
	const response = await http.post<{ message: string }>(`${authBase()}/email/resend`);
	return response.data;
};
